
import { defineComponent } from 'vue';
import Controller from './controllerComponent/index.vue';

const component = defineComponent({
  name: 'teacher-home-route',
  components: {
    Controller,
  },
});

export default component;
